import { Select } from './select.js';

const ArkUiSelect = Select;

export { ArkUiSelect };
